import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { ErrorResponse } from '@src/interface/api/response.interface'
import { getRefunds, ResType } from '@src/lib/api/refund/getRefunds'

type ParamTypes = {
	offset?: number
	limit?: number
	getTotal?: boolean
}

const useGetRefundsQuery = (
	payload: ParamTypes,
	options?: UseQueryOptions<ResType, AxiosError<ErrorResponse>, ResType>,
): UseQueryResult<ResType, AxiosError<ErrorResponse>> => {
	return useQuery<ResType, AxiosError<ErrorResponse>>(
		['getRefunds', payload.offset],
		() => {
			return getRefunds(payload)
		},
		{
			...options,
		},
	)
}

export default useGetRefundsQuery
